import { compactMoney, exactMoney } from '@/lib/format';
import { cn } from '@/lib/utils';

export interface MoneyProps {
  value: number | null | undefined;
  currency?: string;
  /** `$1,2 M` instead of `$1.200.000`; the exact amount stays in the tooltip. */
  compact?: boolean;
  /** Renders `+` on positive amounts, for deltas and adjustments. */
  signed?: boolean;
  /** Text shown when there is no amount at all. */
  placeholder?: string;
  className?: string;
}

/** Currency, always tabular so a column of amounts lines up on the decimal. */
export function Money({
  value,
  currency = 'CLP',
  compact = false,
  signed = false,
  placeholder = '—',
  className,
}: MoneyProps) {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return <span className={cn('tabular text-muted-foreground', className)}>{placeholder}</span>;
  }

  const exact = exactMoney(value, currency);
  const shown = compact ? compactMoney(value, currency) : exact;
  const prefix = signed && value > 0 ? '+' : '';

  return (
    <span className={cn('tabular', className)} title={compact ? exact : undefined}>
      {prefix}
      {shown}
    </span>
  );
}
